import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_dashboard_data = createAsyncThunk("dashboard", async (id) => {
  const body = new FormData();
  body.append("uuid", id);
  const responce = await fetch(baseUrl + "machine-list", {
    method: "POST",
    body: body,
  });
  const res = await responce.json();
  // console.log(res);
  return res;
});

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboard_list: [],
    d_loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(get_dashboard_data.pending, (state, action) => {
      state.d_loading = true;
    });
    builder.addCase(get_dashboard_data.rejected, (state, action) => {
      state.d_loading = false;
    });
    builder.addCase(get_dashboard_data.fulfilled, (state, action) => {
      state.d_loading = false;
      const data = action.payload;
      if (data.success == 0) {
        state.dashboard_list = data.data;
      } else {
        state.dashboard_list = [];
      }
    });
  },
});
export default dashboardSlice.reducer;
